export default {"src":"/_next/static/media/get-verified-get-hired.e76daac2.svg","height":643,"width":664,"blurWidth":0,"blurHeight":0};